import {Directive, ElementRef, HostListener,  Renderer2, } from '@angular/core';

@Directive({
   selector: '[preventOverflow]',
   exportAs: 'preventOverflow'
})
export class PrevenirOverflowMenuDirective{
   constructor(private el: ElementRef, private renderer: Renderer2) {
   }
   
   @HostListener('window:resize') onResize() {
      this.checkOverflow();
   }
   
   private checkOverflow() {
      const element = this.el.nativeElement;
      const overflow = element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth;

      if (overflow) {
         this.renderer.setStyle(element, 'margin-bottom', '0');
      } else {
         this.renderer.removeStyle(element, 'margin-bottom');
      }
   }
}
